/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import store from '../../../../../redux/store';
import { CloseIconSVG } from 'cx-ui-components';

const FiltersTextFieldWrapper = styled.div`
  width: 300px;
  margin-left: 205px;
  margin-top: -10px;
  margin-bottom: 10px;
`;
const QueryText = styled.span`
  display: inline-block;
  font-size: 14px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  padding: 5px;
  background: #ebebeb;
  white-space: pre-wrap;
  margin-top: 5px;
  margin-left: 5px;
`;
const StyledCloseIconSvg = styled(CloseIconSVG)`
  margin-left: 5px;
`;

export const ListField = ({ index, entity, allOrAny, dataSet }) => (
  <Fragment>
    {dataSet && (
      <FiltersTextFieldWrapper>
        {dataSet.map((set, idx) => {
          return (
            <QueryText key={`${entity}-${allOrAny}-${index}-${idx}`}>
              {set.name}
              <StyledCloseIconSvg
                size={10}
                closeIconType="secondary"
                onClick={() =>
                  store.dispatch({
                    type: 'REMOVE_FILTER_ITEM',
                    index: index,
                    entity: entity,
                    allOrAny: allOrAny,
                    removeItemId: set.id,
                  })
                }
              />
            </QueryText>
          );
        })}
      </FiltersTextFieldWrapper>
    )}
  </Fragment>
);

ListField.propTypes = {
  index: PropTypes.number,
  entity: PropTypes.string,
  allOrAny: PropTypes.string,
  dataSet: PropTypes.array,
};
